import { createRoot } from "react-dom/client";
import "./index.css";

import App from "./App.jsx";

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import Home from "./pages/Home.jsx";
import About from "./pages/about/About.jsx";
import UserFormXYZ from "./pages/form/FormXYZ.jsx";
import Profile from "./pages/Profile/Profile.jsx";
import PageNotFound from "./pages/PageNotFound.jsx";
import Payment from "./pages/Payment.jsx";

import AdminLogin from "./pages/AdminLogin.jsx";
import AdminPlayers from "./pages/AdminPlayers.jsx";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,

    children: [
      {
        index: true,
        element: <Home />,
      },

      {
        path: "/form",
        element: <UserFormXYZ />,
      },

      {
        path: "/profile",
        element: <Profile />,
      },

      {
        path: "/about",
        element: <About />,
      },

      // ==========================
      // ADMIN
      // ==========================

      {
        path: "/admin",
        element: <AdminLogin />,
      },

      {
        path: "/admin-player",
        element: <AdminPlayers />,
      },

      // ==========================
      // PAYMENT
      // ==========================

      {
        path: "/payment/:id",
        element: <Payment />,
      },

      // ==========================
      // 404
      // ==========================

      {
        path: "*",
        element: <PageNotFound />,
      },
    ],
  },
]);

createRoot(document.getElementById("root")).render(
  <RouterProvider router={router} />
);